module.exports = __webpack_public_path__ + "static/img/penny_pictgrid17_920x1006.14de7dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid17_920x1006.jpg
// module id = t6B7
// module chunks = 0